import { Breakpoint, ChooseAnswersFieldsGroup, Color, FontWeight, Markdown, Typography } from '@elearning-platform/ui';
import { Interpolation, styled } from 'styled-components';

import { TableCellProps, TableRowProps } from './insuranceTable.types';

export const Container = styled.div`
  background-color: ${Color.Gray100};
  padding: 32px 16px;

  @media ${Breakpoint.Tablet} {
    padding: 32px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 17px;
  border-bottom: 2px solid ${Color.Brand300};
  margin-bottom: 25px;
`;

export const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  display: flex;
  align-items: flex-start;

  @media ${Breakpoint.Tablet} {
    align-items: center;
    flex-direction: row;
  }
`;

export const StyledCheckboxWrapper = styled(CheckboxWrapper)`
  margin-bottom: 25px;
`;

export const StyledTypography = styled(Typography)`
  width: 100px;
`;

export const GrayTypography = styled(Typography)`
  color: ${Color.Gray600};
`;

export const StyledDescription = styled(Markdown)`
  flex-direction: column;
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${Color.Gray300};
  border-left: 1px solid ${Color.Gray300};
  min-width: 763px;
  margin-top: 40px;
`;

export const TableRow = styled.div<TableRowProps>`
  display: flex;
  ${({ $bgColor }: TableRowProps): Interpolation<TableRowProps> => $bgColor && `background-color: ${$bgColor}`}
`;

export const TableCell = styled.div<TableCellProps>`
  width: 24%;
  padding: 18px 16px;
  ${({ $withoutRightBorder }: TableCellProps): Interpolation<TableCellProps> => !$withoutRightBorder && `
    border-right: 1px solid ${Color.Gray300};
  `}
  border-bottom: 1px solid ${Color.Gray300};
  text-wrap: nowrap;
  display: flex;
  align-items: center;
`;

export const SecondColumnCell = styled(TableCell)`
  min-width: 270px;
`;

export const FirstColumnCell = styled(TableCell)`
  width: 200px;
  text-wrap: auto;

  @media ${Breakpoint.Tablet} {
    width: 29%;
  }
`;

export const StyledTableCell = styled(TableCell)`
  width: 563px;

  @media ${Breakpoint.Tablet} {
    width: 71%;
  }
`;

export const StyledMarkdown = styled(Markdown)`
  strong {
    font-weight: ${FontWeight.Bold};
  }
`;

export const StyledCheckboxFieldsGroup = styled(ChooseAnswersFieldsGroup)`
  width: 100%;

  @media ${Breakpoint.Tablet} {
    width: auto;
  }
`;
